import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Merge Tailwind classes, last one winning on a conflict.
 *
 * Every shadcn component wants this as `cn`. The generated source imports it
 * from the **`cn` npm package**, which the `base-nova` registry pulls in and
 * which this repository does not want: it is a third dependency for four
 * lines, the staff-calendar intake's *Strip on adaptation* names it, and
 * `clsx` + `tailwind-merge` are what shadcn's own documentation uses. So the
 * generated files are rewritten to import it from here.
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
